<template>
  <!-- ******** Inicio Card Principal ******** -->

  <v-container
    text-xs-center
    class="pa-4 marginToFooter"
  >
    <v-flex
      xs12
      text-xs-center
    >
      <v-layout
        row
        wrap
        style="align-items: center"
      >
        <v-btn
          flat
          icon
          color="primary"
          to="/contatos"
        >
          <v-icon>
            $vuetify.icons.arrowLeftIcon
          </v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          color="primary"
          to="/contatos"
        >
          Voltar
        </v-btn>
      </v-layout>
    </v-flex>
    <v-layout>
      <TitleChip title="Contato" />
    </v-layout>
    <div
      v-if="!loading"
      class="contact-details mt-4"
    >
      <v-card class="animated fadeIn delay-1s">
        <v-layout
          row
          wrap
          mt-2
          justify-center
          style="align-items: center"
        >
          <v-flex
            xs2
            style="align-items: center"
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.userIcon
            </v-icon>
          </v-flex>

          <v-flex
            xs7
            class="trunk"
            style="align-items: center"
          >
            <v-subheader>
              {{ contato.nome ? contato.nome : '' }} {{ contato.sobrenome ? contato.sobrenome : '' }}
              <v-icon
                v-if="contato.primeiraCompra"
                small
                color="primary"
                class="ml-1"
              >
                star
              </v-icon>
              <v-icon
                v-if="contato.best"
                small
                color="primary"
                class="ml-1"
              >
                favorite
              </v-icon>
            </v-subheader>
          </v-flex>

          <v-flex xs1>
            <v-btn
              v-if="contato.situacao == 'LEAD'"
              color="grey"
              outline
              small
              icon
              @click="deleteDialog = true"
            >
              <v-icon
                small
                color="grey"
              >
                delete_forever
              </v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs2 />
        </v-layout>

        <v-layout
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-icon
              class="avatarFonts"
              medium
              :color="receiveMessage.color"
            >
              {{ receiveMessage.icon }}
            </v-icon>
          </v-flex>

          <v-flex xs8>
            <v-subheader
              v-if="!contato.blocked"
              @click="countCall"
            >
              <a :href="contato.celular | telHref">{{ contato.celular | fullPhone }}</a>
            </v-subheader>
            <v-subheader
              v-else
              @click="countCall"
            >
              Não Informado
            </v-subheader>
          </v-flex>

          <v-flex xs2>
            <v-btn
              v-if="!contato.blocked && contato.celular && contato.celular.valid"
              color="grey"
              flat
              small
              icon
              :href="contato.celular | whatsappUrl"
              target="_blank"
              @click="countWpp"
            >
              <v-icon color="primary">
                fab fa-whatsapp
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="contato.customerId !== '61b907480287e25e99a71b26'"
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.mailIcon
            </v-icon>
          </v-flex>

          <v-flex xs10>
            <v-subheader>{{ contato.email && contato.email.value ? contato.email.value : 'Não Informado' }}</v-subheader>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="contato.customerId !== '61b907480287e25e99a71b26'"
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.cpfIcon
            </v-icon>
          </v-flex>

          <v-flex xs10>
            <v-subheader>{{ contato.cpf && contato.cpf.value ? contato.cpf.value : 'Não Informado' }}</v-subheader>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.cakeIcon
            </v-icon>
          </v-flex>

          <v-flex xs10>
            <v-subheader>{{ contato.nascimento | formattedDate }}</v-subheader>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="contato.loyalty && contato.loyalty.current && contato.customerId !== '5f3960ccdb0e3500032c99ad'"
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.giftIcon
            </v-icon>
          </v-flex>

          <v-flex xs10>
            <v-subheader>{{ contato.loyalty.current }} pontos</v-subheader>
          </v-flex>
        </v-layout>
        <v-layout
          v-if="contato.loyalty && contato.loyalty.current"
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.clockIcon
            </v-icon>
          </v-flex>

          <v-flex xs10>
            <v-subheader>{{ contato.loyalty.expiringAmount }} expirando em {{ contato.loyalty.expiring | dateShort }}</v-subheader>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          justify-center
        >
          <v-flex
            xs2
            mt-2
          >
            <v-switch
              v-model="switch1"
              class="swBtn"
              color="#099AB1"
              :disabled="switch1"
              @change="muteUser"
            />
          </v-flex>

          <v-flex
            xs10
            mt-2
          >
            <v-subheader>{{ blockLabel }}</v-subheader>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          justify-center
        />
      </v-card>

      <!-- ******** Inicio Card Secundario ******** -->
      <v-card class="mt-2 animated fadeIn delay-1s">
        <v-layout
          row
          wrap
          mt-2
          align-center
        >
          <v-flex
            xs4
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.cartIcon
            </v-icon>
          </v-flex>

          <!-- <v-flex xs3 mt-2>
          <v-icon medium color="#099AB1">attach_money</v-icon>
          </v-flex>-->

          <v-flex
            xs4
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.moneyCircleIcon
            </v-icon>
          </v-flex>

          <v-flex
            xs4
            mt-2
          >
            <v-icon
              medium
              color="primary"
            >
              $vuetify.icons.heartIcon
            </v-icon>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          mt-2
          align-center
        >
          <v-flex xs4>
            <span>Compras</span>
          </v-flex>

          <!-- <v-flex xs3>
          <span class="menu2">Total Gasto</span>
          </v-flex>-->

          <v-flex xs4>
            <span>Ticket Medio</span>
          </v-flex>

          <v-flex xs4>
            <span>Cat. Favorita</span>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          mt-2
          align-center
        >
          <v-flex
            xs4
            mb-2
          >
            <strong class="menu2">{{ contato.quantidadePedidos }}</strong>
          </v-flex>

          <!-- <v-flex xs3 mb-2>
          <strong class="menu2">{{contato.totalGasto | currency}}</strong>
          </v-flex>-->

          <v-flex
            xs4
            mb-2
          >
            <strong class="menu2">{{ contato.ticketMedio | currency }}</strong>
          </v-flex>

          <v-flex
            xs4
            mb-2
          >
            <strong
              v-if="!contato.categoriasPreferidas || contato.categoriasPreferidas.length == 1"
              class="menu2"
            >{{ contato.categoriasPreferidas | formatCategorias }}</strong>
            <a
              v-if="contato.categoriasPreferidas && contato.categoriasPreferidas.length > 1"
            >{{ contato.categoriasPreferidas | formatCategorias }}</a>
          </v-flex>
        </v-layout>
      </v-card>

      <div class="animated fadeIn delay-1s mt-2">
        <v-layout
          row
          wrap
          justify-center
        >
          <v-flex>
            <Notifications :person="contato" />
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="mt-2">
        <TitleChip title="Histórico de Pedidos" />
      </v-layout>
      <v-card class="customCard mt-2">
        <HistoricoPedidos
          :contato="contato"
          class="pa-2"
        />
      </v-card>
    </div>

    <v-snackbar
      v-model="snackbar"
      class="snackBar"
      :color="color"
      :top="true"
      :multi-line="true"
      :timeout="9999999"
    >
      {{ snackText }}
      <v-btn
        class="snackbar-btn"
        width="675px"
        outline
        @click="snackbar = false"
      >
        Ok
      </v-btn>
    </v-snackbar>

    <!-- ******** Enquanto a pagina nao carrega ******** -->
    <div
      v-if="loading"
      class="text-xs-center mt-3"
    >
      <v-progress-circular
        :size="50"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>

    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card class="dialogCard">
        <v-card-title class>
          Deseja remover o registro?
        </v-card-title>

        <v-card-actions>
          <v-spacer />

          <v-btn
            round
            small
            outline
            flat="flat"
            class="text-lowercase"
            @click="deleteDialog = false"
          >
            cancelar
          </v-btn>

          <v-btn
            round
            small
            outline
            flat="flat"
            class="text-lowercase"
            @click="deletePerson"
          >
            remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import format from 'date-fns/format';
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import RegistrarComentario from '@/components/RegistrarComentario.vue';
import { APIService } from '@/resources/campanha.js';
import { EventBus } from '@/event-bus.js';
import { PersonOptOut } from '@/apollo';

const api = new APIService();

export default {

  filters: {
    formatCategorias: (value) => (value && value.length > 1 ? 'Multiplas' : value ? value[0] : null),
    fullPhone: (value) => {
      if (!value) return 'Nao informado';
      if (value.valid === false) return value.original;
      return `+55 (${value.phoneArea ? value.phoneArea : '00'}) ${value.phone ? value.phone : ''}`;
    },
    whatsappUrl: (value) => `http://api.whatsapp.com/send?phone=${value.countryCode}${value.phoneArea}${value.phone}`,
    telHref: (value) => (value ? `tel:+${value.countryCode}${value.phoneArea}${value.phone}` : '#'),

    formattedDate: (item) => (item ? format(item, 'DD/MM/YYYY') : 'Não Informado'),
  },
  data() {
    return {
      deleteDialog: false,
      counterBlock: 0,
      counterCall: 0,
      counterWpp: 0,
      formattedPhone: null,
      window: {
        width: 0,
        height: 0,
      },
      snackbar: false,
      snackText: '',
      color: '',
      isEditing: false,
      switch1: true,
      receiveMessage: [],
      blockLabel: '',
      items: [],
      loading: true,
      contato: null,
      historicos: [],
    };
  },
  computed: {
    ...mapState(['tasks']),
  },
  async mounted() {
    await this.getContact();
    // this.getHistorico();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    emitSnackBar() {
      const snackBar = {};
      snackBar.text = 'Lead removido com sucesso!';
      snackBar.value = true;
      snackBar.color = '#FFADDE';
      EventBus.$emit('activeSnackBar', snackBar);
    },
    deletePerson() {
      api.deletePerson(this.contato).then(async (data) => {
        await this.$store.dispatch('carregarListaContatos', { user: this.$auth.user, force: true });
        this.emitSnackBar();
        this.deleteDialog = false;
        this.$router.push('/contatos');
      });
    },
    countWpp() {
      this.counterWpp += 1;

      this.$ga.event({
        eventCategory: 'Agenda',
        eventAction: 'Enviar Whats',
        eventValue: this.counterWpp,
      });
    },
    countCall() {
      this.counterCall += 1;

      this.$ga.event({
        eventCategory: 'Agenda',
        eventAction: 'Ligar',
        eventValue: this.counterCall,
      });
    },
    async muteUser() {
      try {
        this.counterBlock += 1;

        this.$ga.event({
          eventCategory: 'Agenda',
          eventAction: 'Bloquear',
          eventValue: this.counterBlock,
        });

        if (this.switch1) {
          this.receiveMessage.icon = 'fas fa-phone-slash';
          this.receiveMessage.status = 'Bloqueado';
          this.receiveMessage.color = 'primary';
          this.blockLabel = 'Cliente solicitou para não enviar mensagens';
          const res = await this.$apollo.query({
            query: PersonOptOut,
            variables: {
              person: {
                phone: this.contato.celular.fullNumber,
                cpf: this.contato.cpf.value,
                customerId: this.contato.customerId,
              },
            },
            fetchPolicy: 'no-cache',
          });
          if (res.data) {
            this.snackbar = true;
            this.snackText = 'Cliente bloqueado com sucesso!';
            this.isEditing = false;
            this.color = '#FFADDE';
            this.contato.blocked = true;
          }
        } else {
          this.blockLabel = 'Bloquear envio de mensagens';
        }
      } catch (err) {
        console.log(err);
      }
    },
    updatePerson() {
      api.updatePerson(this.contato);
    },
    async getContact() {
      this.contato = await api.getContact(this.$route.params.id);
      this.loading = false;
      if (
        !this.contato.blocked
        || (this.contato.blocked && this.contato.blocked === false)
      ) {
        this.receiveMessage.icon = '$vuetify.icons.phoneIcon';
        this.receiveMessage.color = 'primary';
        this.switch1 = false;
        this.blockLabel = 'Bloquear envio de mensagens';
      } else {
        this.receiveMessage.icon = '$vuetify.icons.phoneIcon';
        this.receiveMessage.color = 'primary';
        this.switch1 = true;
        this.blockLabel = 'Cliente solicitou para não enviar mensagens';
      }
    },
    async getHistorico() {
      if (this.contato.celular.phone) {
        const leadCustomer = await api.leadCustomer(
          this.contato.customerId,
          this.contato.celular.phoneArea,
          this.contato.celular.phone,
        );
        this.historicos = (await api.getCampaignResult(
          leadCustomer.id,
        ))._embedded.campaignResults;
        for (const historico of this.historicos) {
          if (historico.dataEnvio != null) {
            historico.dataEnvio = format(historico.dataEnvio, 'DD/MM/YYYY');
          }
          if (historico.dataEnvio === null) {
            historico.dataEnvio = 'Indefinido';
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.sideMenu {
  color: #099AB1;
}

.dialogCard {
  box-shadow: none;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>

<style scoped>

.trunk {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.iconBtn {
  font-size: 14px !important;
}

.menu3 {
  font-size: 8px;
}

.menu4 {
  font-size: 11px;
}
.menuTextbox {
  font-size: 12px;
}

.footerm {
  margin-top: 10px;
}

.marginToFooter {
  margin-bottom: 75px;
}
.avatarFonts {
  font-size: 22px !important;
}
.swBtn {
  margin-top: 8px;
  display: -webkit-inline-box;
  padding-left: 16px;
}
</style>

<style scoped>
.v-card {
  box-shadow: none;
  border-radius: 10px;
}

.theme--light.v-sheet {
  border: 1px solid #e0e0e0;
}
.voltar {
  margin: 0px !important;
  padding: 0px !important;
}
.contact-details {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px !important;
  line-height: 18px;
}
.v-subheader {
    font-size: 12px !important;
    color: #433D4E !important;
}
.menu2 {
color: #0C4439;
}
::v-deep .snackBar {
  color: #140C22 !important;
  caret-color: #140C22 !important;
  text-align: left !important;
  box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.1) !important;
}
.snackbar-btn {
  border-radius: 7.08982px;
  color: #140C22 !important;
  caret-color: #140C22 !important;
  min-width: 83px !important;
}
.save-btn {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  /* or 150% */
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: none;
}
</style>
